import classnames from 'classnames';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';
import { kebabCase } from 'lodash';
import entityComposition from '../common/classes/entityComposition';
import { labelSelector, newPathSelector, styleSelector } from './selectors';
import widthSelector from './selectors/widthSelector';

// this component wraps every container.
const GridCol = ({
  format,
  children: _children = null,
  // eslint-disable-next-line no-unused-vars
  content: _content = null,
  label: _label = null,
  // eslint-disable-next-line no-unused-vars
  minControlWidth: _minControlWidth = 0,
  // eslint-disable-next-line no-unused-vars
  width: _width = {
    size: 12
  },
  // eslint-disable-next-line no-unused-vars
  style: _style = null
}) => {
  const className = useMemo(() => {
    let result = 'align-self-end';
    result = classnames('GridCol', result);
    if (format.horizontalAlignment) {
      result = classnames(result, `horz-align-${format.horizontalAlignment}`);
    }

    // to preserve webtests.  maybe we want this to go away - especially with v2.
    if (format.type === 'row') {
      const header = format.type === 'section' ? undefined : _label;
      result = classnames({
        't-grid-row': true,
        [`t-grid-row-${kebabCase(header)}`]: !!header,
        'content-row': true
      });
    }
    return result;
  }, [format.horizontalAlignment, format.type, _label]);
  if (_children === undefined) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Row, {
    className: className,
    "data-testid": "grid-col"
  }, _children);
};
GridCol.propTypes = {
  content: PropTypes.shape({}),
  format: PropTypes.shape({
    collapsible: PropTypes.bool,
    horizontalAlignment: PropTypes.string,
    type: PropTypes.string
  }).isRequired,
  children: PropTypes.node,
  label: PropTypes.string,
  minControlWidth: PropTypes.number,
  style: PropTypes.shape({}),
  width: PropTypes.shape({})
};
export { GridCol as UncomposedGridCol, widthSelector as testWidthSelector };
export default entityComposition(GridCol, [], {
  label: labelSelector,
  width: widthSelector,
  style: styleSelector,
  path: newPathSelector
});